import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBookingGroups } from "../../../redux/actions/todoPerformance";
import CreateGroupModel from "./Chat/CreateGroupModel";
import StartThread from "./Chat/StartThread";
import ChatIndex from "./Chat/ChatIndex";
import { RESET_BOOKING_GROUPS, SET_THREAD_COUNTER } from "../../../redux/constants";

const ChatTab = () => {
  const dispatch = useDispatch();
  const {
    performancedata,
    subGroup,
  } = useSelector((state) => state.todoPerformance);
  const {email} = useSelector(state => state.auth);

  const [createGroupModel, setCreateGroupModel] = useState(false);

  useEffect(() => {
    if (performancedata.activity_assignment_id){
      dispatch(getBookingGroups(performancedata.activity_assignment_id, (res) => {
        const counter = res.data?.filter(item => item.is_read?.includes(email)) || [];
        dispatch({type: SET_THREAD_COUNTER, payload: counter.length });
      }))
    }
    return () => {
      dispatch({type: RESET_BOOKING_GROUPS})
    }
  }, [dispatch, performancedata.activity_assignment_id]);

  // Create a thread for booking
  const handleCreateThread = () => {
    setCreateGroupModel(true);
  };

  return (
    <div
      className="w-full h-full"
      style={{ maxHeight: "calc(100vh - 136px)" }}
    >
      {subGroup.length === 0 ? (
        <StartThread handleCreateThread={handleCreateThread} />
      ) : (
        <ChatIndex />
      )}

      <CreateGroupModel
        modalOpen={createGroupModel}
        setModelOpen={setCreateGroupModel}
        activity_assignment_id={performancedata.activity_assignment_id}
      />
    </div>
  );
};

export default ChatTab;
